/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251223
*/
'use strict';
import {
    getBannedMembersAsync,
    toggleBannedAsync
} from './snMembersManagement.js';

import { setMenu } from './snSite.js';

let bannedMembers = [];  

const getBannedMembersRow = (params) => {
    return '<tr id="row' + params.data.id + '">' +
        '<td class="col-md-3">' + params.data.name + '</td>' +
        '<td class="col-md-4">' + params.data.email + '</td>' +
        '<td class="col-md-3">' + params.data.phone + '</td>' +
        '<td class="col-md-2"><button title="Allow ' + params.data.name +
        ' to use My Sermon Notes..." class="btn btn-default btn-sm" ' +
        ' data-toggle="modal" data-target="#confirmDlg" data-caller="unblock" data-key="' +
        params.data.id + '"><span class="fa fa-undo"></span>  Unblock</button></td>' +
        '</tr>';
}

const initConfirmDlg = () => {
    $('#confirmDlg').on('show.bs.modal', (e) => {
        const caller = e.relatedTarget.dataset.caller,
            key = e.relatedTarget.dataset.key,
            idx = bannedMembers.findIndex(x => x.id === parseInt(key, 10)),
            member = bannedMembers[idx];
        switch (caller) {
            case 'unblock':
                $('#confirmDlgPrompt').text(`When you unblock ${member.name}, they can join your church profile on My Sermon Notes. Proceed?`)
                break;
            default:
                alert('Unknown caller');
                return;
        }
        $('#btnConfirm').off().on('click', async () => {
            switch (caller) {
                case 'unblock':
                    await toggleBannedAsync({
                        mg: member.mg,
                        divErrMsg: 'divConfirmDlgErrMsg'
                    })
                    bannedMembers.splice(idx, 1);
                    ctssHtml.getTableRows({ arr: bannedMembers, fnGetRow: getBannedMembersRow, gridNm: 'gridBlockedMembers' });
                    $('#confirmDlg').modal('hide');
                    $('#successDlgPrompt').text(`${member.name} has been unblocked!`)
                    $('#successDlg').modal('show');
                    break;
            }
        });
    });
}

const initAsync = async () => {
    setMenu();
    try {
        bannedMembers = await getBannedMembersAsync();
        ctssHtml.getTableRows({ arr: bannedMembers, fnGetRow: getBannedMembersRow, gridNm: 'gridBlockedMembers' });

    }
    catch (err) { }; 

    initConfirmDlg();
};

window.snUnblockMember = {
    initAsync
};